import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Alert } from 'react-bootstrap';
import ModifMdpVerification from './modifMdpVerification';



function Connexion() {
  const [isError,setIsError]= useState(false) 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); 
  const [showMdp, setShowMdp] = useState(false)
  const Navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;



  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          { withCredentials: true }  
        );


        if (response.data.user && response.data.user.type) {
          switch (response.data.user.type) {
            case "coach":
              Navigate('/coach/accueil');
              break;
            case "joueur":
              Navigate('/joueurs/accueil');
              break;
            case "arbitre":
              Navigate('/arbitre/accueil');
              break;
            case "admin":
              Navigate('/admin');
              break;
            default:
              Navigate('/connexion');
              break;
          }
        } else {
          Navigate('/connexion');
        }
      } catch (error) {
        Navigate('/connexion');
      }
    };

    checkAuth();
  }, [Navigate, apiUrl]);
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); 


    if (!email || !password ) {
      setError("Veuillez remplir tous les champs du formulaire.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/authentification/connexion`, {
        mail: email,
        mdp: password
      }, {
        withCredentials: true 
      });

      setIsError(false);
      setError(null);
      setIsLoading(false);

      if (response.data.user.type === "coach"){
        Navigate('/coach/accueil');
      }
      if (response.data.user.type === "joueur"){
        Navigate('/joueurs/accueil');
      }
      if (response.data.user.type === "arbitre"){
        Navigate('/arbitre/accueil');
      }
      if (response.data.user.type === "admin"){
        Navigate('/admin');
      }


    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        
        setError(error.response.data.message);
      } else {
        
        setIsError(true)
      }
    }
  };

  const ShowMdpFalse = () => {
    setShowMdp(false);
  };


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    ); 
  }
  

  if (isError) {
    return (
      <div id="alert-message" className="alert5" >
      <strong>ERROR ! </strong>Erreur Serveur <span id="alert-text"></span>
  </div>
    
    ); 
  }
  


  return (
    <>
      {showMdp && (
        <ModifMdpVerification showMdp={showMdp} showMDPFalse={ShowMdpFalse} />
      )}
      <div className="container_co">
      {error && 
        <Alert key="danger" variant="danger">
        {error}
      </Alert>
      }
        <h1 className="title">Connexion</h1>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="Email" className="label-1">
              <br />Email<br />
              <input
                name="mail"
                type="email"
                id="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
          </div>
          <div>
            <label htmlFor="Motpasse" className="label-1">
              <br />Mot de passe<br />
              <input
                name="mdp"
                type="password"
                id="Motpasse"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          </div>
          <div>
            <a href="/connexion" onClick={(event) => { event.preventDefault(); setShowMdp(true)}} className="forget">
              Mot de passe oublié ?
            </a>
            <button type="submit" className="conect">
              Connexion
            </button>
          </div>
          <br/>
          <br/>
          </form>

      </div>
      
    </>
  );
}


export default Connexion;
